module.exports = __webpack_public_path__ + "img/background.19e62050.jpg";